import { render, staticRenderFns } from "./ReavaliacaoList.vue?vue&type=template&id=9ece894a"
import script from "./ReavaliacaoList.vue?vue&type=script&lang=js"
export * from "./ReavaliacaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports